import { useState } from "react";

const filters = ["Todos", "Em oferta", "Seleção da editora", "Novidades"];

const WHATSAPP_URL = "https://wa.me/message/6X77HRWZGKPQH1";

export default function Hero() {
  const [active, setActive] = useState<string>("Todos");

  return (
    <section className="w-full bg-background-50 px-4 md:px-8 pt-10 md:pt-16 pb-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-[12px] font-medium">
            <i className="ri-leaf-line"></i>
            Decoração & casa
          </span>
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl lg:text-[56px] font-medium leading-tight mt-5">
            Um lar com alma, feito de peças à mão
          </h2>
          <p className="text-foreground-700 text-base md:text-lg mt-4 max-w-xl mx-auto leading-relaxed">
            Cerâmica, vasos, almofadas e velas selecionadas de artesãos de todo
            o Brasil, para deixar a sua casa com a sua cara.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#featured"
              className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Ver produtos
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 h-12 px-7 rounded-full border border-foreground-300 hover:border-foreground-900 text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-[18px]"></i>
              Falar no WhatsApp
            </a>
          </div>
        </div>

        {/* Filter pills */}
        <div className="mt-9 flex items-center justify-center flex-wrap gap-2">
          {filters.map((f) => {
            const isActive = active === f;
            return (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`inline-flex items-center h-9 px-4 rounded-full border text-[13px] font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "bg-foreground-950 text-background-50 border-foreground-950"
                    : "bg-background-50 text-foreground-900 border-background-300 hover:border-foreground-900"
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}